import styled from '@emotion/styled';
import { useContext } from 'react';

import { ApplicationContext } from '../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

const PurchaseInformation = styled.div({
    alignItems: 'center',
    backgroundColor: '#F1F1F0',
    color: '#6E6E6C',
    display: 'flex',
    fontFamily: 'FT Regola Neue',
    fontWeight: '400',
    height: '2.5rem',
    justifyContent: 'flex-start',
    lineHeight: '1.25rem',
    paddingLeft: '1.25rem',
});

const ContactSalesButton = styled.button({
    background: 'inherit',
    border: 'none',
    color: 'inherit',
    cursor: 'pointer',
    font: 'inherit',
    fontWeight: 'inherit',
    textDecoration: 'underline solid',
    textUnderlineOffset: '0.1875rem',
});

export const trialPeriodDays = 7;

export const TrialInformation: FunctionComponent<{ readonly daysRemaining: number }> = (properties) => {
    const { translate } = useContext(ApplicationContext);
    const { daysRemaining } = properties;

    return (
        <PurchaseInformation>
            {`${translate('trial.trial-ends-in')} ${daysRemaining} ${translate('common.days')}.`}
            <ContactSalesButton>{translate('trial.contact-sales')}</ContactSalesButton>
            {translate('trial.keep-using-cobrainer')}
        </PurchaseInformation>
    );
};
